export const getLangNameFromLocale = (locale) =>
  ({ en: "English", es: "Español" }[locale])
